// Material UI
import { makeStyles } from '@material-ui/core'
// Constants
import Colors from '../../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${Colors.DISABLED_COLOR}`,
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto min-content',
    padding: 16,
  },
  feedbackRate: {},
  feedbackBox: {
    padding: 16,
  },
  button: {
    textAlign: 'right',
  },
}))
